<div class="integration-page">
  <app-freeswitch-integration-toolbar (add)="openAddModal()" />

  <app-freeswitch-integration-list
    [instances]="instances"
    [loading]="loading"
    [canDelete]="canDelete"
    (edit)="openEditModal($event)"
    (delete)="openDeleteModal($event)"
    (console)="openConsoleModal($event)" />

  <app-freeswitch-integration-form
    *ngIf="showFormModal"
    [visible]="true"
    [isEdit]="isEditMode"
    [instance]="selectedInstance"
    [instancesCount]="instances.length"
    (visibleChange)="onFormVisibilityChange($event)"
    (saved)="onFormSaved($event)" />

  <app-freeswitch-instance-console
    *ngIf="showConsoleModal"
    [visible]="true"
    [instance]="consoleInstance"
    (visibleChange)="onConsoleVisibilityChange($event)" />
</div>
